/**
 * Static ISO state/region reference data for every country — bulk data, not
 * maintained by hand entry by entry.
 *
 * Only `interfaces/location/index.ts` and `utils/australianState.ts` read it.
 * The latter narrows to `countryCode === "AU"` once at module load; the former
 * filters by whatever country it is asked for, so this is not an
 * Australia-only table. There is nothing to learn from scrolling the ~2,300
 * lines below; go to those two consumers instead.
 */
export const statesList = [
    {
        countryCode: "AU",
        isoCode: "ACT",
        latitude: "-35.28346000",
        longitude: "149.12807000",
        name: "Australian Capital Territory"
    },
    {
        countryCode: "AU",
        isoCode: "NSW",
        latitude: "-31.25321830",
        longitude: "146.92109900",
        name: "New South Wales"
    },
    {
        countryCode: "AU",
        isoCode: "NT",
        latitude: "-19.49141080",
        longitude: "132.55096030",
        name: "Northern Territory"
    },
    {
        countryCode: "AU",
        isoCode: "QLD",
        latitude: "-20.91757380",
        longitude: "142.70279560",
        name: "Queensland"
    },
    {
        countryCode: "AU",
        isoCode: "SA",
        latitude: "-30.00023150",
        longitude: "136.20915470",
        name: "South Australia"
    },
    {
        countryCode: "AU",
        isoCode: "TAS",
        latitude: "-41.45451960",
        longitude: "145.97066470",
        name: "Tasmania"
    },
    {
        countryCode: "AU",
        isoCode: "VIC",
        latitude: "-36.48564230",
        longitude: "140.97794250",
        name: "Victoria"
    },
    {
        countryCode: "AU",
        isoCode: "WA",
        latitude: "-27.67281680",
        longitude: "121.62830980",
        name: "Western Australia"
    },
    {
        countryCode: "CA",
        isoCode: "AB",
        latitude: "53.93327060",
        longitude: "-116.57650350",
        name: "Alberta"
    },
    {
        countryCode: "CA",
        isoCode: "BC",
        latitude: "53.72666830",
        longitude: "-127.64762050",
        name: "British Columbia"
    },
    {
        countryCode: "CA",
        isoCode: "MB",
        latitude: "53.76086080",
        longitude: "-98.81387620",
        name: "Manitoba"
    },
    {
        countryCode: "CA",
        isoCode: "NB",
        latitude: "46.56531630",
        longitude: "-66.46191640",
        name: "New Brunswick"
    },
    {
        countryCode: "CA",
        isoCode: "NL",
        latitude: "53.13550910",
        longitude: "-57.66043640",
        name: "Newfoundland and Labrador"
    },
    {
        countryCode: "CA",
        isoCode: "NS",
        latitude: "44.68198660",
        longitude: "-63.74431100",
        name: "Nova Scotia"
    },
    {
        countryCode: "CA",
        isoCode: "NT",
        latitude: "64.82554410",
        longitude: "-124.84573340",
        name: "Northwest Territories"
    },
    {
        countryCode: "CA",
        isoCode: "NU",
        latitude: "70.29977110",
        longitude: "-83.10757700",
        name: "Nunavut"
    },
    {
        countryCode: "CA",
        isoCode: "ON",
        latitude: "51.25377500",
        longitude: "-85.32321400",
        name: "Ontario"
    },
    {
        countryCode: "CA",
        isoCode: "PE",
        latitude: "46.51071200",
        longitude: "-63.41681360",
        name: "Prince Edward Island"
    },
    {
        countryCode: "CA",
        isoCode: "QC",
        latitude: "52.93991590",
        longitude: "-73.54913610",
        name: "Quebec"
    },
    {
        countryCode: "CA",
        isoCode: "SK",
        latitude: "52.93991590",
        longitude: "-106.45086390",
        name: "Saskatchewan"
    },
    {
        countryCode: "CA",
        isoCode: "YT",
        latitude: "35.50672150",
        longitude: "-97.76254410",
        name: "Yukon"
    },
    {
        countryCode: "GB",
        isoCode: "ABC",
        latitude: "54.39325920",
        longitude: "-6.45634010",
        name: "Armagh, Banbridge and Craigavon"
    },
    {
        countryCode: "GB",
        isoCode: "ABD",
        latitude: "57.28687230",
        longitude: "-2.38156840",
        name: "Aberdeenshire"
    },
    {
        countryCode: "GB",
        isoCode: "ABE",
        latitude: "57.14971700",
        longitude: "-2.09427800",
        name: "Aberdeen"
    },
    {
        countryCode: "GB",
        isoCode: "AGB",
        latitude: "56.40062140",
        longitude: "-5.48074800",
        name: "Argyll and Bute"
    },
    {
        countryCode: "GB",
        isoCode: "AND",
        latitude: "54.58996450",
        longitude: "-5.59849720",
        name: "Ards and North Down"
    },
    {
        countryCode: "GB",
        isoCode: "ANN",
        latitude: "54.69568870",
        longitude: "-5.94810690",
        name: "Antrim and Newtownabbey"
    },
    {
        countryCode: "GB",
        isoCode: "ANS",
        latitude: "37.27578860",
        longitude: "-95.65010330",
        name: "Angus"
    },
    {
        countryCode: "GB",
        isoCode: "ANT",
        latitude: "54.71953380",
        longitude: "-6.20724980",
        name: "Antrim"
    },
    {
        countryCode: "GB",
        isoCode: "ARD",
        latitude: "42.13918510",
        longitude: "-87.86149720",
        name: "Ards"
    },
    {
        countryCode: "GB",
        isoCode: "ARM",
        latitude: "54.39325920",
        longitude: "-6.45634010",
        name: "Armagh City and District Council"
    },
    {
        countryCode: "GB",
        isoCode: "BAS",
        latitude: "51.32501020",
        longitude: "-2.47662410",
        name: "Bath and North East Somerset"
    },
    {
        countryCode: "GB",
        isoCode: "BBD",
        latitude: "53.69575220",
        longitude: "-2.46829850",
        name: "Blackburn with Darwen"
    },
    {
        countryCode: "GB",
        isoCode: "BDF",
        latitude: "32.84401700",
        longitude: "-97.14306710",
        name: "Bedford"
    },
    {
        countryCode: "GB",
        isoCode: "BDG",
        latitude: "51.55406660",
        longitude: "0.13401700",
        name: "London Borough of Barking and Dagenham"
    },
    {
        countryCode: "GB",
        isoCode: "BEN",
        latitude: "51.56728080",
        longitude: "-0.27105680",
        name: "London Borough of Brent"
    },
    {
        countryCode: "GB",
        isoCode: "BEX",
        latitude: "51.45190210",
        longitude: "0.11717860",
        name: "London Borough of Bexley"
    },
    {
        countryCode: "GB",
        isoCode: "BFS",
        latitude: "54.61703660",
        longitude: "-5.95318610",
        name: "Belfast district"
    },
    {
        countryCode: "GB",
        isoCode: "BGE",
        latitude: "51.50831990",
        longitude: "-3.58120750",
        name: "Bridgend County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "BGW",
        latitude: "51.78757790",
        longitude: "-3.20439310",
        name: "Blaenau Gwent County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "BIR",
        latitude: "33.51858920",
        longitude: "-86.81035670",
        name: "Birmingham"
    },
    {
        countryCode: "GB",
        isoCode: "BKM",
        latitude: "51.80722040",
        longitude: "-0.81276640",
        name: "Buckinghamshire"
    },
    {
        countryCode: "GB",
        isoCode: "BLA",
        latitude: "54.86426000",
        longitude: "-6.27910740",
        name: "Ballymena Borough"
    },
    {
        countryCode: "GB",
        isoCode: "BLY",
        latitude: "55.07048880",
        longitude: "-6.51737080",
        name: "Ballymoney"
    },
    {
        countryCode: "GB",
        isoCode: "BMH",
        latitude: "50.71916400",
        longitude: "-1.88076900",
        name: "Bournemouth"
    },
    {
        countryCode: "GB",
        isoCode: "BNB",
        latitude: "54.34872900",
        longitude: "-6.27048030",
        name: "Banbridge"
    },
    {
        countryCode: "GB",
        isoCode: "BNE",
        latitude: "51.60496730",
        longitude: "-0.20762950",
        name: "London Borough of Barnet"
    },
    {
        countryCode: "GB",
        isoCode: "BNH",
        latitude: "50.82262880",
        longitude: "-0.13704700",
        name: "Brighton and Hove"
    },
    {
        countryCode: "GB",
        isoCode: "BNS",
        latitude: "34.29949560",
        longitude: "-84.98458090",
        name: "Barnsley"
    },
    {
        countryCode: "GB",
        isoCode: "BOL",
        latitude: "44.37264760",
        longitude: "-72.87876250",
        name: "Bolton"
    },
    {
        countryCode: "GB",
        isoCode: "BPL",
        latitude: "53.81750530",
        longitude: "-3.03567480",
        name: "Blackpool"
    },
    {
        countryCode: "GB",
        isoCode: "BRC",
        latitude: "51.41538280",
        longitude: "-0.75364950",
        name: "Bracknell Forest"
    },
    {
        countryCode: "GB",
        isoCode: "BRD",
        latitude: "53.79598400",
        longitude: "-1.75939800",
        name: "Bradford"
    },
    {
        countryCode: "GB",
        isoCode: "BRY",
        latitude: "51.36797050",
        longitude: "0.07006200",
        name: "London Borough of Bromley"
    },
    {
        countryCode: "GB",
        isoCode: "BST",
        latitude: "41.67352200",
        longitude: "-72.94653750",
        name: "City of Bristol"
    },
    {
        countryCode: "GB",
        isoCode: "BUR",
        latitude: "53.59334980",
        longitude: "-2.29660540",
        name: "Bury"
    },
    {
        countryCode: "GB",
        isoCode: "CAM",
        latitude: "52.20529730",
        longitude: "0.12181950",
        name: "Cambridgeshire"
    },
    {
        countryCode: "GB",
        isoCode: "CAY",
        latitude: "51.66044650",
        longitude: "-3.21787240",
        name: "Caerphilly County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "CBF",
        latitude: "52.00297440",
        longitude: "-0.46513890",
        name: "Central Bedfordshire"
    },
    {
        countryCode: "GB",
        isoCode: "CCG",
        latitude: "55.04318300",
        longitude: "-6.67412880",
        name: "Causeway Coast and Glens"
    },
    {
        countryCode: "GB",
        isoCode: "CGN",
        latitude: "52.21914290",
        longitude: "-3.93212560",
        name: "Ceredigion"
    },
    {
        countryCode: "GB",
        isoCode: "CGV",
        latitude: "54.39325920",
        longitude: "-6.45634010",
        name: "Craigavon Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "CHE",
        latitude: "53.16104460",
        longitude: "-2.21859320",
        name: "Cheshire East"
    },
    {
        countryCode: "GB",
        isoCode: "CHW",
        latitude: "53.23029740",
        longitude: "-2.71511170",
        name: "Cheshire West and Chester"
    },
    {
        countryCode: "GB",
        isoCode: "CKF",
        latitude: "54.72568430",
        longitude: "-5.80937190",
        name: "Carrickfergus Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "CKT",
        latitude: "54.64181580",
        longitude: "-6.74438950",
        name: "Cookstown District Council"
    },
    {
        countryCode: "GB",
        isoCode: "CLD",
        latitude: "53.72478450",
        longitude: "-1.86583570",
        name: "Calderdale"
    },
    {
        countryCode: "GB",
        isoCode: "CLK",
        latitude: "56.10753510",
        longitude: "-3.75294090",
        name: "Clackmannanshire"
    },
    {
        countryCode: "GB",
        isoCode: "CLR",
        latitude: "55.14515700",
        longitude: "-6.67598140",
        name: "Coleraine Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "CMA",
        latitude: "54.57723230",
        longitude: "-2.79748350",
        name: "Cumbria"
    },
    {
        countryCode: "GB",
        isoCode: "CMD",
        latitude: "51.54547360",
        longitude: "-0.16279020",
        name: "London Borough of Camden"
    },
    {
        countryCode: "GB",
        isoCode: "CMN",
        latitude: "51.85723090",
        longitude: "-4.31159590",
        name: "Carmarthenshire"
    },
    {
        countryCode: "GB",
        isoCode: "CON",
        latitude: "50.26604710",
        longitude: "-5.05271250",
        name: "Cornwall"
    },
    {
        countryCode: "GB",
        isoCode: "COV",
        latitude: "52.40682200",
        longitude: "-1.51969300",
        name: "Coventry"
    },
    {
        countryCode: "GB",
        isoCode: "CRF",
        latitude: "51.48158100",
        longitude: "-3.17909000",
        name: "City and County of Cardiff"
    },
    {
        countryCode: "GB",
        isoCode: "CRY",
        latitude: "51.38274460",
        longitude: "-0.09851630",
        name: "London Borough of Croydon"
    },
    {
        countryCode: "GB",
        isoCode: "CSR",
        latitude: "54.57567900",
        longitude: "-5.88840280",
        name: "Castlereagh"
    },
    {
        countryCode: "GB",
        isoCode: "CWY",
        latitude: "53.29350130",
        longitude: "-3.72651610",
        name: "Conwy County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "DAL",
        latitude: "34.29987620",
        longitude: "-79.87617410",
        name: "Darlington"
    },
    {
        countryCode: "GB",
        isoCode: "DBY",
        latitude: "53.10467820",
        longitude: "-1.56238850",
        name: "Derbyshire"
    },
    {
        countryCode: "GB",
        isoCode: "DEN",
        latitude: "53.18422880",
        longitude: "-3.42249850",
        name: "Denbighshire"
    },
    {
        countryCode: "GB",
        isoCode: "DER",
        latitude: "37.54837550",
        longitude: "-97.24851910",
        name: "City of Derby"
    },
    {
        countryCode: "GB",
        isoCode: "DEV",
        latitude: "50.71555910",
        longitude: "-3.53087500",
        name: "Devon"
    },
    {
        countryCode: "GB",
        isoCode: "DGN",
        latitude: "54.50826840",
        longitude: "-6.76658910",
        name: "Dungannon and South Tyrone Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "DGY",
        latitude: "55.07010730",
        longitude: "-3.60525810",
        name: "Dumfries and Galloway"
    },
    {
        countryCode: "GB",
        isoCode: "DNC",
        latitude: "53.52282000",
        longitude: "-1.12846200",
        name: "Doncaster"
    },
    {
        countryCode: "GB",
        isoCode: "DND",
        latitude: "56.46201800",
        longitude: "-2.97072100",
        name: "Dundee"
    },
    {
        countryCode: "GB",
        isoCode: "DOR",
        latitude: "50.74876350",
        longitude: "-2.34447860",
        name: "Dorset"
    },
    {
        countryCode: "GB",
        isoCode: "DOW",
        latitude: "54.24342870",
        longitude: "-5.95779590",
        name: "Down District Council"
    },
    {
        countryCode: "GB",
        isoCode: "DRS",
        latitude: "55.00474430",
        longitude: "-7.32092220",
        name: "Derry City and Strabane"
    },
    {
        countryCode: "GB",
        isoCode: "DRY",
        latitude: "54.96907780",
        longitude: "-7.19583510",
        name: "Derry City Council"
    },
    {
        countryCode: "GB",
        isoCode: "DUD",
        latitude: "42.04336610",
        longitude: "-71.92760330",
        name: "Dudley"
    },
    {
        countryCode: "GB",
        isoCode: "DUR",
        latitude: "54.72940990",
        longitude: "-1.88115980",
        name: "County Durham"
    },
    {
        countryCode: "GB",
        isoCode: "EAL",
        latitude: "51.52503660",
        longitude: "-0.34139650",
        name: "London Borough of Ealing"
    },
    {
        countryCode: "GB",
        isoCode: "EAY",
        latitude: "55.45184960",
        longitude: "-4.26444780",
        name: "East Ayrshire"
    },
    {
        countryCode: "GB",
        isoCode: "EDH",
        latitude: "55.95325200",
        longitude: "-3.18826700",
        name: "Edinburgh"
    },
    {
        countryCode: "GB",
        isoCode: "EDU",
        latitude: "55.97431620",
        longitude: "-4.20229800",
        name: "East Dunbartonshire"
    },
    {
        countryCode: "GB",
        isoCode: "ELN",
        latitude: "55.94933830",
        longitude: "-2.77044640",
        name: "East Lothian"
    },
    {
        countryCode: "GB",
        isoCode: "ELS",
        latitude: "57.75989180",
        longitude: "-7.01940340",
        name: "Outer Hebrides"
    },
    {
        countryCode: "GB",
        isoCode: "ENF",
        latitude: "51.66229090",
        longitude: "-0.11806510",
        name: "London Borough of Enfield"
    },
    {
        countryCode: "GB",
        isoCode: "ENG",
        latitude: "52.35551770",
        longitude: "-1.17431970",
        name: "England"
    },
    {
        countryCode: "GB",
        isoCode: "ERW",
        latitude: "55.77047350",
        longitude: "-4.33598210",
        name: "East Renfrewshire"
    },
    {
        countryCode: "GB",
        isoCode: "ERY",
        latitude: "53.84161680",
        longitude: "-0.43441060",
        name: "East Riding of Yorkshire"
    },
    {
        countryCode: "GB",
        isoCode: "ESS",
        latitude: "51.57424470",
        longitude: "0.48567810",
        name: "Essex"
    },
    {
        countryCode: "GB",
        isoCode: "ESX",
        latitude: "50.90859550",
        longitude: "0.24941660",
        name: "East Sussex"
    },
    {
        countryCode: "GB",
        isoCode: "FAL",
        latitude: "56.00187750",
        longitude: "-3.78391310",
        name: "Falkirk"
    },
    {
        countryCode: "GB",
        isoCode: "FER",
        latitude: "54.34479780",
        longitude: "-7.63842180",
        name: "Fermanagh District Council"
    },
    {
        countryCode: "GB",
        isoCode: "FIF",
        latitude: "56.20820780",
        longitude: "-3.14951750",
        name: "Fife"
    },
    {
        countryCode: "GB",
        isoCode: "FLN",
        latitude: "53.16686580",
        longitude: "-3.14189080",
        name: "Flintshire"
    },
    {
        countryCode: "GB",
        isoCode: "FMO",
        latitude: "54.45135240",
        longitude: "-7.71250180",
        name: "Fermanagh and Omagh"
    },
    {
        countryCode: "GB",
        isoCode: "GAT",
        latitude: "54.95268000",
        longitude: "-1.60341100",
        name: "Gateshead"
    },
    {
        countryCode: "GB",
        isoCode: "GLG",
        latitude: "55.86423700",
        longitude: "-4.25180600",
        name: "Glasgow"
    },
    {
        countryCode: "GB",
        isoCode: "GLS",
        latitude: "51.86421120",
        longitude: "-2.23803350",
        name: "Gloucestershire"
    },
    {
        countryCode: "GB",
        isoCode: "GRE",
        latitude: "51.48346270",
        longitude: "0.05862020",
        name: "Royal Borough of Greenwich"
    },
    {
        countryCode: "GB",
        isoCode: "GWN",
        latitude: "52.92772660",
        longitude: "-4.13348360",
        name: "Gwynedd"
    },
    {
        countryCode: "GB",
        isoCode: "HAL",
        latitude: "43.53253720",
        longitude: "-79.87448360",
        name: "Halton"
    },
    {
        countryCode: "GB",
        isoCode: "HAM",
        latitude: "51.05769480",
        longitude: "-1.30806290",
        name: "Hampshire"
    },
    {
        countryCode: "GB",
        isoCode: "HAV",
        latitude: "51.57792400",
        longitude: "0.21208290",
        name: "London Borough of Havering"
    },
    {
        countryCode: "GB",
        isoCode: "HCK",
        latitude: "51.57344500",
        longitude: "-0.07243760",
        name: "London Borough of Hackney"
    },
    {
        countryCode: "GB",
        isoCode: "HEF",
        latitude: "52.07651640",
        longitude: "-2.65441820",
        name: "Herefordshire"
    },
    {
        countryCode: "GB",
        isoCode: "HIL",
        latitude: "51.53518320",
        longitude: "-0.44813780",
        name: "London Borough of Hillingdon"
    },
    {
        countryCode: "GB",
        isoCode: "HLD",
        latitude: "36.29675080",
        longitude: "-95.83803660",
        name: "Highland"
    },
    {
        countryCode: "GB",
        isoCode: "HMF",
        latitude: "51.49901560",
        longitude: "-0.22915000",
        name: "London Borough of Hammersmith and Fulham"
    },
    {
        countryCode: "GB",
        isoCode: "HNS",
        latitude: "51.48283580",
        longitude: "-0.38820620",
        name: "London Borough of Hounslow"
    },
    {
        countryCode: "GB",
        isoCode: "HPL",
        latitude: "54.69174500",
        longitude: "-1.21292600",
        name: "Hartlepool"
    },
    {
        countryCode: "GB",
        isoCode: "HRT",
        latitude: "51.80978230",
        longitude: "-0.23767440",
        name: "Hertfordshire"
    },
    {
        countryCode: "GB",
        isoCode: "HRW",
        latitude: "51.58816270",
        longitude: "-0.34228510",
        name: "London Borough of Harrow"
    },
    {
        countryCode: "GB",
        isoCode: "HRY",
        latitude: "51.59061130",
        longitude: "-0.11097090",
        name: "London Borough of Haringey"
    },
    {
        countryCode: "GB",
        isoCode: "IOS",
        latitude: "49.92772610",
        longitude: "-6.32749660",
        name: "Isles of Scilly"
    },
    {
        countryCode: "GB",
        isoCode: "IOW",
        latitude: "50.69384790",
        longitude: "-1.30473400",
        name: "Isle of Wight"
    },
    {
        countryCode: "GB",
        isoCode: "ISL",
        latitude: "51.54650630",
        longitude: "-0.10580580",
        name: "London Borough of Islington"
    },
    {
        countryCode: "GB",
        isoCode: "IVC",
        latitude: "55.93165690",
        longitude: "-4.68001580",
        name: "Inverclyde"
    },
    {
        countryCode: "GB",
        isoCode: "KEC",
        latitude: "51.49908050",
        longitude: "-0.19382530",
        name: "Royal Borough of Kensington and Chelsea"
    },
    {
        countryCode: "GB",
        isoCode: "KEN",
        latitude: "41.15366740",
        longitude: "-81.35788590",
        name: "Kent"
    },
    {
        countryCode: "GB",
        isoCode: "KHL",
        latitude: "53.76762360",
        longitude: "-0.32741980",
        name: "City of Kingston upon Hull"
    },
    {
        countryCode: "GB",
        isoCode: "KIR",
        latitude: "53.59334320",
        longitude: "-1.80095090",
        name: "Kirklees"
    },
    {
        countryCode: "GB",
        isoCode: "KTT",
        latitude: "51.37811700",
        longitude: "-0.29270900",
        name: "Royal Borough of Kingston upon Thames"
    },
    {
        countryCode: "GB",
        isoCode: "KWL",
        latitude: "53.45459400",
        longitude: "-2.85290700",
        name: "Knowsley"
    },
    {
        countryCode: "GB",
        isoCode: "LAN",
        latitude: "53.76322540",
        longitude: "-2.70440520",
        name: "Lancashire"
    },
    {
        countryCode: "GB",
        isoCode: "LBC",
        latitude: "54.49815840",
        longitude: "-6.13067910",
        name: "Lisburn and Castlereagh"
    },
    {
        countryCode: "GB",
        isoCode: "LBH",
        latitude: "51.45714770",
        longitude: "-0.12306810",
        name: "London Borough of Lambeth"
    },
    {
        countryCode: "GB",
        isoCode: "LCE",
        latitude: "52.63687780",
        longitude: "-1.13975920",
        name: "City of Leicester"
    },
    {
        countryCode: "GB",
        isoCode: "LDS",
        latitude: "53.80075540",
        longitude: "-1.54907740",
        name: "Leeds"
    },
    {
        countryCode: "GB",
        isoCode: "LEC",
        latitude: "52.77257100",
        longitude: "-1.20521260",
        name: "Leicestershire"
    },
    {
        countryCode: "GB",
        isoCode: "LEW",
        latitude: "51.44145790",
        longitude: "-0.01170060",
        name: "London Borough of Lewisham"
    },
    {
        countryCode: "GB",
        isoCode: "LIN",
        latitude: "52.94518890",
        longitude: "-0.16012460",
        name: "Lincolnshire"
    },
    {
        countryCode: "GB",
        isoCode: "LIV",
        latitude: "32.65649810",
        longitude: "-115.47632410",
        name: "Liverpool"
    },
    {
        countryCode: "GB",
        isoCode: "LMV",
        latitude: "55.05168200",
        longitude: "-6.94919440",
        name: "Limavady Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "LND",
        latitude: "51.51234430",
        longitude: "-0.09098520",
        name: "City of London"
    },
    {
        countryCode: "GB",
        isoCode: "LRN",
        latitude: "54.85780030",
        longitude: "-5.82362240",
        name: "Larne Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "LSB",
        latitude: "54.49815840",
        longitude: "-6.13067910",
        name: "Lisburn City Council"
    },
    {
        countryCode: "GB",
        isoCode: "MAN",
        latitude: "53.48075930",
        longitude: "-2.24263050",
        name: "Manchester"
    },
    {
        countryCode: "GB",
        isoCode: "MDB",
        latitude: "54.57422700",
        longitude: "-1.23495600",
        name: "Middlesbrough"
    },
    {
        countryCode: "GB",
        isoCode: "MDW",
        latitude: "42.14176410",
        longitude: "-71.39672560",
        name: "Medway"
    },
    {
        countryCode: "GB",
        isoCode: "MEA",
        latitude: "54.93993410",
        longitude: "-6.11374230",
        name: "Mid and East Antrim"
    },
    {
        countryCode: "GB",
        isoCode: "MFT",
        latitude: "54.75532790",
        longitude: "-6.60774870",
        name: "Magherafelt District Council"
    },
    {
        countryCode: "GB",
        isoCode: "MIK",
        latitude: "52.08520380",
        longitude: "-0.73331330",
        name: "Milton Keynes"
    },
    {
        countryCode: "GB",
        isoCode: "MLN",
        latitude: "32.47533500",
        longitude: "-97.01031810",
        name: "Midlothian"
    },
    {
        countryCode: "GB",
        isoCode: "MON",
        latitude: "51.81161000",
        longitude: "-2.71634170",
        name: "Monmouthshire"
    },
    {
        countryCode: "GB",
        isoCode: "MRT",
        latitude: "51.40977420",
        longitude: "-0.21080840",
        name: "London Borough of Merton"
    },
    {
        countryCode: "GB",
        isoCode: "MRY",
        latitude: "57.64984760",
        longitude: "-3.31680390",
        name: "Moray"
    },
    {
        countryCode: "GB",
        isoCode: "MTY",
        latitude: "51.74674740",
        longitude: "-3.38132750",
        name: "Merthyr Tydfil County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "MUL",
        latitude: "54.64113010",
        longitude: "-6.75225490",
        name: "Mid Ulster"
    },
    {
        countryCode: "GB",
        isoCode: "MYL",
        latitude: "55.20473270",
        longitude: "-6.25317400",
        name: "Moyle District Council"
    },
    {
        countryCode: "GB",
        isoCode: "NAY",
        latitude: "55.64167310",
        longitude: "-4.75946000",
        name: "North Ayrshire"
    },
    {
        countryCode: "GB",
        isoCode: "NBL",
        latitude: "55.20825420",
        longitude: "-2.07841380",
        name: "Northumberland"
    },
    {
        countryCode: "GB",
        isoCode: "NDN",
        latitude: "54.65362970",
        longitude: "-5.67249250",
        name: "North Down Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "NEL",
        latitude: "53.56682010",
        longitude: "-0.08150660",
        name: "North East Lincolnshire"
    },
    {
        countryCode: "GB",
        isoCode: "NET",
        latitude: "54.97825200",
        longitude: "-1.61778000",
        name: "Newcastle upon Tyne"
    },
    {
        countryCode: "GB",
        isoCode: "NFK",
        latitude: "36.85076890",
        longitude: "-76.28587260",
        name: "Norfolk"
    },
    {
        countryCode: "GB",
        isoCode: "NGM",
        latitude: "52.95478320",
        longitude: "-1.15810860",
        name: "City of Nottingham"
    },
    {
        countryCode: "GB",
        isoCode: "NIR",
        latitude: "54.78771490",
        longitude: "-6.49231450",
        name: "Northern Ireland"
    },
    {
        countryCode: "GB",
        isoCode: "NLK",
        latitude: "55.86624320",
        longitude: "-3.96131440",
        name: "North Lanarkshire"
    },
    {
        countryCode: "GB",
        isoCode: "NLN",
        latitude: "53.60555920",
        longitude: "-0.55965820",
        name: "North Lincolnshire"
    },
    {
        countryCode: "GB",
        isoCode: "NMD",
        latitude: "54.24342870",
        longitude: "-5.95779590",
        name: "Newry, Mourne and Down"
    },
    {
        countryCode: "GB",
        isoCode: "NSM",
        latitude: "51.38790280",
        longitude: "-2.77810910",
        name: "North Somerset"
    },
    {
        countryCode: "GB",
        isoCode: "NTA",
        latitude: "54.67924220",
        longitude: "-5.95911020",
        name: "Newtownabbey Borough Council"
    },
    {
        countryCode: "GB",
        isoCode: "NTH",
        latitude: "52.27299440",
        longitude: "-0.87555150",
        name: "Northamptonshire"
    },
    {
        countryCode: "GB",
        isoCode: "NTL",
        latitude: "51.59785190",
        longitude: "-3.78396680",
        name: "Neath Port Talbot County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "NTT",
        latitude: "53.10031900",
        longitude: "-0.99363060",
        name: "Nottinghamshire"
    },
    {
        countryCode: "GB",
        isoCode: "NTY",
        latitude: "55.01823990",
        longitude: "-1.48584360",
        name: "North Tyneside"
    },
    {
        countryCode: "GB",
        isoCode: "NWM",
        latitude: "51.52551620",
        longitude: "0.03521630",
        name: "London Borough of Newham"
    },
    {
        countryCode: "GB",
        isoCode: "NWP",
        latitude: "37.52782340",
        longitude: "-94.10438760",
        name: "Newport"
    },
    {
        countryCode: "GB",
        isoCode: "NYK",
        latitude: "53.99150280",
        longitude: "-1.54120150",
        name: "North Yorkshire"
    },
    {
        countryCode: "GB",
        isoCode: "NYM",
        latitude: "54.17425050",
        longitude: "-6.33919920",
        name: "Newry and Mourne District Council"
    },
    {
        countryCode: "GB",
        isoCode: "OLD",
        latitude: "42.20405980",
        longitude: "-71.20481190",
        name: "Oldham"
    },
    {
        countryCode: "GB",
        isoCode: "OMH",
        latitude: "54.45135240",
        longitude: "-7.71250180",
        name: "Omagh District Council"
    },
    {
        countryCode: "GB",
        isoCode: "ORK",
        latitude: "58.98094010",
        longitude: "-2.96052060",
        name: "Orkney Islands"
    },
    {
        countryCode: "GB",
        isoCode: "OXF",
        latitude: "51.76120560",
        longitude: "-1.24646740",
        name: "Oxfordshire"
    },
    {
        countryCode: "GB",
        isoCode: "PEM",
        latitude: "51.67407800",
        longitude: "-4.90887850",
        name: "Pembrokeshire"
    },
    {
        countryCode: "GB",
        isoCode: "PKN",
        latitude: "56.39538170",
        longitude: "-3.42835470",
        name: "Perth and Kinross"
    },
    {
        countryCode: "GB",
        isoCode: "PLY",
        latitude: "42.37089410",
        longitude: "-83.46971410",
        name: "City of Plymouth"
    },
    {
        countryCode: "GB",
        isoCode: "POL",
        latitude: "50.71505000",
        longitude: "-1.98724800",
        name: "Poole"
    },
    {
        countryCode: "GB",
        isoCode: "POR",
        latitude: "36.83291500",
        longitude: "-76.29755490",
        name: "City of Portsmouth"
    },
    {
        countryCode: "GB",
        isoCode: "POW",
        latitude: "52.64642490",
        longitude: "-3.32609040",
        name: "Powys"
    },
    {
        countryCode: "GB",
        isoCode: "PTE",
        latitude: "44.30936360",
        longitude: "-78.32015300",
        name: "City of Peterborough"
    },
    {
        countryCode: "GB",
        isoCode: "RCC",
        latitude: "54.59713440",
        longitude: "-1.07759970",
        name: "Redcar and Cleveland"
    },
    {
        countryCode: "GB",
        isoCode: "RCH",
        latitude: "53.60971360",
        longitude: "-2.15610000",
        name: "Rochdale"
    },
    {
        countryCode: "GB",
        isoCode: "RCT",
        latitude: "51.64902070",
        longitude: "-3.42886920",
        name: "Rhondda Cynon Taf"
    },
    {
        countryCode: "GB",
        isoCode: "RDB",
        latitude: "51.58861210",
        longitude: "0.08239820",
        name: "London Borough of Redbridge"
    },
    {
        countryCode: "GB",
        isoCode: "RDG",
        latitude: "36.14866590",
        longitude: "-95.98400120",
        name: "Reading"
    },
    {
        countryCode: "GB",
        isoCode: "RFW",
        latitude: "55.84665400",
        longitude: "-4.53312590",
        name: "Renfrewshire"
    },
    {
        countryCode: "GB",
        isoCode: "RIC",
        latitude: "51.46130540",
        longitude: "-0.30377090",
        name: "London Borough of Richmond upon Thames"
    },
    {
        countryCode: "GB",
        isoCode: "ROT",
        latitude: "53.43260350",
        longitude: "-1.36350090",
        name: "Rotherham"
    },
    {
        countryCode: "GB",
        isoCode: "RUT",
        latitude: "43.61062370",
        longitude: "-72.97260650",
        name: "Rutland"
    },
    {
        countryCode: "GB",
        isoCode: "SAW",
        latitude: "52.53616740",
        longitude: "-2.01079300",
        name: "Sandwell"
    },
    {
        countryCode: "GB",
        isoCode: "SAY",
        latitude: "55.45889880",
        longitude: "-4.62919940",
        name: "South Ayrshire"
    },
    {
        countryCode: "GB",
        isoCode: "SCB",
        latitude: "55.54856970",
        longitude: "-2.78613880",
        name: "Scottish Borders"
    },
    {
        countryCode: "GB",
        isoCode: "SCT",
        latitude: "56.49067120",
        longitude: "-4.20264580",
        name: "Scotland"
    },
    {
        countryCode: "GB",
        isoCode: "SFK",
        latitude: "52.18724720",
        longitude: "0.97078010",
        name: "Suffolk"
    },
    {
        countryCode: "GB",
        isoCode: "SFT",
        latitude: "53.50344490",
        longitude: "-2.97035900",
        name: "Sefton"
    },
    {
        countryCode: "GB",
        isoCode: "SGC",
        latitude: "51.52643610",
        longitude: "-2.47284870",
        name: "South Gloucestershire"
    },
    {
        countryCode: "GB",
        isoCode: "SH-AC",
        latitude: "-7.94671660",
        longitude: "-14.35591580",
        name: "Ascension Island"
    },
    {
        countryCode: "GB",
        isoCode: "SH-HL",
        latitude: "-15.96501040",
        longitude: "-5.70892410",
        name: "Saint Helena"
    },
    {
        countryCode: "GB",
        isoCode: "SHF",
        latitude: "36.09507430",
        longitude: "-80.27884660",
        name: "Sheffield"
    },
    {
        countryCode: "GB",
        isoCode: "SHN",
        latitude: "45.85896100",
        longitude: "-122.82123560",
        name: "St Helens"
    },
    {
        countryCode: "GB",
        isoCode: "SHR",
        latitude: "52.70636570",
        longitude: "-2.74178490",
        name: "Shropshire"
    },
    {
        countryCode: "GB",
        isoCode: "SKP",
        latitude: "53.41063160",
        longitude: "-2.15753320",
        name: "Stockport"
    },
    {
        countryCode: "GB",
        isoCode: "SLF",
        latitude: "53.48752350",
        longitude: "-2.29012640",
        name: "Salford"
    },
    {
        countryCode: "GB",
        isoCode: "SLG",
        latitude: "51.51053840",
        longitude: "-0.59504060",
        name: "Slough"
    },
    {
        countryCode: "GB",
        isoCode: "SLK",
        latitude: "55.67359090",
        longitude: "-3.78196610",
        name: "South Lanarkshire"
    },
    {
        countryCode: "GB",
        isoCode: "SND",
        latitude: "54.88614890",
        longitude: "-1.47857970",
        name: "City of Sunderland"
    },
    {
        countryCode: "GB",
        isoCode: "SOL",
        latitude: "52.41181100",
        longitude: "-1.77761000",
        name: "Solihull"
    },
    {
        countryCode: "GB",
        isoCode: "SOM",
        latitude: "51.10509700",
        longitude: "-2.92623070",
        name: "Somerset"
    },
    {
        countryCode: "GB",
        isoCode: "SOS",
        latitude: "51.54592690",
        longitude: "0.70771230",
        name: "Southend-on-Sea"
    },
    {
        countryCode: "GB",
        isoCode: "SRY",
        latitude: "51.31475930",
        longitude: "-0.55995010",
        name: "Surrey"
    },
    {
        countryCode: "GB",
        isoCode: "STB",
        latitude: "54.82738650",
        longitude: "-7.46331030",
        name: "Strabane District Council"
    },
    {
        countryCode: "GB",
        isoCode: "STE",
        latitude: "53.00266800",
        longitude: "-2.17940400",
        name: "City of Stoke-on-Trent"
    },
    {
        countryCode: "GB",
        isoCode: "STG",
        latitude: "56.11652270",
        longitude: "-3.93690290",
        name: "Stirling"
    },
    {
        countryCode: "GB",
        isoCode: "STH",
        latitude: "50.90970040",
        longitude: "-1.40435090",
        name: "City of Southampton"
    },
    {
        countryCode: "GB",
        isoCode: "STN",
        latitude: "51.35737620",
        longitude: "-0.17527960",
        name: "London Borough of Sutton"
    },
    {
        countryCode: "GB",
        isoCode: "STS",
        latitude: "52.87927450",
        longitude: "-2.05718680",
        name: "Staffordshire"
    },
    {
        countryCode: "GB",
        isoCode: "STT",
        latitude: "54.57045510",
        longitude: "-1.32898210",
        name: "Stockton-on-Tees"
    },
    {
        countryCode: "GB",
        isoCode: "STY",
        latitude: "54.96366930",
        longitude: "-1.44186340",
        name: "South Tyneside"
    },
    {
        countryCode: "GB",
        isoCode: "SWA",
        latitude: "51.62144000",
        longitude: "-3.94364600",
        name: "City and County of Swansea"
    },
    {
        countryCode: "GB",
        isoCode: "SWD",
        latitude: "51.55577390",
        longitude: "-1.77971760",
        name: "Swindon"
    },
    {
        countryCode: "GB",
        isoCode: "SWK",
        latitude: "51.48805720",
        longitude: "-0.07628380",
        name: "London Borough of Southwark"
    },
    {
        countryCode: "GB",
        isoCode: "TAM",
        latitude: "53.48058280",
        longitude: "-2.08098910",
        name: "Tameside"
    },
    {
        countryCode: "GB",
        isoCode: "TFW",
        latitude: "52.74099160",
        longitude: "-2.48685860",
        name: "Telford and Wrekin"
    },
    {
        countryCode: "GB",
        isoCode: "THR",
        latitude: "51.49345570",
        longitude: "0.35291970",
        name: "Thurrock"
    },
    {
        countryCode: "GB",
        isoCode: "TOB",
        latitude: "50.43923290",
        longitude: "-3.53698990",
        name: "Torbay"
    },
    {
        countryCode: "GB",
        isoCode: "TOF",
        latitude: "51.70022530",
        longitude: "-3.04460150",
        name: "Torfaen"
    },
    {
        countryCode: "GB",
        isoCode: "TRF",
        latitude: "40.38562460",
        longitude: "-79.75893470",
        name: "Trafford"
    },
    {
        countryCode: "GB",
        isoCode: "TWH",
        latitude: "51.52026070",
        longitude: "-0.02933960",
        name: "London Borough of Tower Hamlets"
    },
    {
        countryCode: "GB",
        isoCode: "UKM",
        latitude: "55.37805100",
        longitude: "-3.43597300",
        name: "United Kingdom"
    },
    {
        countryCode: "GB",
        isoCode: "VGL",
        latitude: "51.40959580",
        longitude: "-3.48481670",
        name: "Vale of Glamorgan"
    },
    {
        countryCode: "GB",
        isoCode: "WAR",
        latitude: "52.26713530",
        longitude: "-1.46752160",
        name: "Warwickshire"
    },
    {
        countryCode: "GB",
        isoCode: "WBK",
        latitude: "51.43082550",
        longitude: "-1.14449270",
        name: "West Berkshire"
    },
    {
        countryCode: "GB",
        isoCode: "WDU",
        latitude: "55.94509250",
        longitude: "-4.56462590",
        name: "West Dunbartonshire"
    },
    {
        countryCode: "GB",
        isoCode: "WFT",
        latitude: "51.58863830",
        longitude: "-0.01176250",
        name: "London Borough of Waltham Forest"
    },
    {
        countryCode: "GB",
        isoCode: "WGN",
        latitude: "53.51348120",
        longitude: "-2.61069990",
        name: "Metropolitan Borough of Wigan"
    },
    {
        countryCode: "GB",
        isoCode: "WIL",
        latitude: "51.34919960",
        longitude: "-1.99271050",
        name: "Wiltshire"
    },
    {
        countryCode: "GB",
        isoCode: "WKF",
        latitude: "42.50393950",
        longitude: "-71.07233910",
        name: "Wakefield"
    },
    {
        countryCode: "GB",
        isoCode: "WLL",
        latitude: "52.58621400",
        longitude: "-1.98291900",
        name: "Walsall"
    },
    {
        countryCode: "GB",
        isoCode: "WLN",
        latitude: "55.90701980",
        longitude: "-3.55171670",
        name: "West Lothian"
    },
    {
        countryCode: "GB",
        isoCode: "WLS",
        latitude: "52.13066070",
        longitude: "-3.78371170",
        name: "Wales"
    },
    {
        countryCode: "GB",
        isoCode: "WLV",
        latitude: "52.58891200",
        longitude: "-2.15646300",
        name: "City of Wolverhampton"
    },
    {
        countryCode: "GB",
        isoCode: "WND",
        latitude: "51.45682740",
        longitude: "-0.18966380",
        name: "London Borough of Wandsworth"
    },
    {
        countryCode: "GB",
        isoCode: "WNM",
        latitude: "51.47997120",
        longitude: "-0.62425650",
        name: "Windsor and Maidenhead"
    },
    {
        countryCode: "GB",
        isoCode: "WOK",
        latitude: "51.41045700",
        longitude: "-0.83386100",
        name: "Wokingham"
    },
    {
        countryCode: "GB",
        isoCode: "WOR",
        latitude: "52.25452250",
        longitude: "-2.26683820",
        name: "Worcestershire"
    },
    {
        countryCode: "GB",
        isoCode: "WRL",
        latitude: "53.37271810",
        longitude: "-3.07375400",
        name: "Wirral"
    },
    {
        countryCode: "GB",
        isoCode: "WRT",
        latitude: "40.24927410",
        longitude: "-75.13406040",
        name: "Warrington"
    },
    {
        countryCode: "GB",
        isoCode: "WRX",
        latitude: "53.03013780",
        longitude: "-3.02614870",
        name: "Wrexham County Borough"
    },
    {
        countryCode: "GB",
        isoCode: "WSM",
        latitude: "39.57659770",
        longitude: "-76.99721260",
        name: "City of Westminster"
    },
    {
        countryCode: "GB",
        isoCode: "WSX",
        latitude: "50.92801430",
        longitude: "-0.46170750",
        name: "West Sussex"
    },
    {
        countryCode: "GB",
        isoCode: "YOR",
        latitude: "53.95996510",
        longitude: "-1.08729790",
        name: "City of York"
    },
    {
        countryCode: "GB",
        isoCode: "ZET",
        latitude: "60.52965070",
        longitude: "-1.26594090",
        name: "Shetland Islands"
    },
    {
        countryCode: "US",
        isoCode: "AK",
        latitude: "64.20084130",
        longitude: "-149.49367330",
        name: "Alaska"
    },
    {
        countryCode: "US",
        isoCode: "AL",
        latitude: "32.31823140",
        longitude: "-86.90229800",
        name: "Alabama"
    },
    {
        countryCode: "US",
        isoCode: "AR",
        latitude: "35.20105000",
        longitude: "-91.83183340",
        name: "Arkansas"
    },
    {
        countryCode: "US",
        isoCode: "AS",
        latitude: "-14.27097200",
        longitude: "-170.13221700",
        name: "American Samoa"
    },
    {
        countryCode: "US",
        isoCode: "AZ",
        latitude: "34.04892810",
        longitude: "-111.09373110",
        name: "Arizona"
    },
    {
        countryCode: "US",
        isoCode: "CA",
        latitude: "36.77826100",
        longitude: "-119.41793240",
        name: "California"
    },
    {
        countryCode: "US",
        isoCode: "CO",
        latitude: "39.55005070",
        longitude: "-105.78206740",
        name: "Colorado"
    },
    {
        countryCode: "US",
        isoCode: "CT",
        latitude: "41.60322070",
        longitude: "-73.08774900",
        name: "Connecticut"
    },
    {
        countryCode: "US",
        isoCode: "DC",
        latitude: "38.90719230",
        longitude: "-77.03687070",
        name: "District of Columbia"
    },
    {
        countryCode: "US",
        isoCode: "DE",
        latitude: "38.91083250",
        longitude: "-75.52766990",
        name: "Delaware"
    },
    {
        countryCode: "US",
        isoCode: "FL",
        latitude: "27.66482740",
        longitude: "-81.51575350",
        name: "Florida"
    },
    {
        countryCode: "US",
        isoCode: "GA",
        latitude: "32.16562210",
        longitude: "-82.90007510",
        name: "Georgia"
    },
    {
        countryCode: "US",
        isoCode: "GU",
        latitude: "13.44430400",
        longitude: "144.79373100",
        name: "Guam"
    },
    {
        countryCode: "US",
        isoCode: "HI",
        latitude: "19.89676620",
        longitude: "-155.58278180",
        name: "Hawaii"
    },
    {
        countryCode: "US",
        isoCode: "IA",
        latitude: "41.87800250",
        longitude: "-93.09770200",
        name: "Iowa"
    },
    {
        countryCode: "US",
        isoCode: "ID",
        latitude: "44.06820190",
        longitude: "-114.74204080",
        name: "Idaho"
    },
    {
        countryCode: "US",
        isoCode: "IL",
        latitude: "40.63312490",
        longitude: "-89.39852830",
        name: "Illinois"
    },
    {
        countryCode: "US",
        isoCode: "IN",
        latitude: "40.26719410",
        longitude: "-86.13490190",
        name: "Indiana"
    },
    {
        countryCode: "US",
        isoCode: "KS",
        latitude: "39.01190200",
        longitude: "-98.48424650",
        name: "Kansas"
    },
    {
        countryCode: "US",
        isoCode: "KY",
        latitude: "37.83933320",
        longitude: "-84.27001790",
        name: "Kentucky"
    },
    {
        countryCode: "US",
        isoCode: "LA",
        latitude: "30.98429770",
        longitude: "-91.96233270",
        name: "Louisiana"
    },
    {
        countryCode: "US",
        isoCode: "MA",
        latitude: "42.40721070",
        longitude: "-71.38243740",
        name: "Massachusetts"
    },
    {
        countryCode: "US",
        isoCode: "MD",
        latitude: "39.04575490",
        longitude: "-76.64127120",
        name: "Maryland"
    },
    {
        countryCode: "US",
        isoCode: "ME",
        latitude: "45.25378300",
        longitude: "-69.44546890",
        name: "Maine"
    },
    {
        countryCode: "US",
        isoCode: "MI",
        latitude: "44.31484430",
        longitude: "-85.60236430",
        name: "Michigan"
    },
    {
        countryCode: "US",
        isoCode: "MN",
        latitude: "46.72955300",
        longitude: "-94.68589980",
        name: "Minnesota"
    },
    {
        countryCode: "US",
        isoCode: "MO",
        latitude: "37.96425290",
        longitude: "-91.83183340",
        name: "Missouri"
    },
    {
        countryCode: "US",
        isoCode: "MP",
        latitude: "15.09790000",
        longitude: "145.67390000",
        name: "Northern Mariana Islands"
    },
    {
        countryCode: "US",
        isoCode: "MS",
        latitude: "32.35466790",
        longitude: "-89.39852830",
        name: "Mississippi"
    },
    {
        countryCode: "US",
        isoCode: "MT",
        latitude: "46.87968220",
        longitude: "-110.36256580",
        name: "Montana"
    },
    {
        countryCode: "US",
        isoCode: "NC",
        latitude: "35.75957310",
        longitude: "-79.01929970",
        name: "North Carolina"
    },
    {
        countryCode: "US",
        isoCode: "ND",
        latitude: "47.55149260",
        longitude: "-101.00201190",
        name: "North Dakota"
    },
    {
        countryCode: "US",
        isoCode: "NE",
        latitude: "41.49253740",
        longitude: "-99.90181310",
        name: "Nebraska"
    },
    {
        countryCode: "US",
        isoCode: "NH",
        latitude: "43.19385160",
        longitude: "-71.57239530",
        name: "New Hampshire"
    },
    {
        countryCode: "US",
        isoCode: "NJ",
        latitude: "40.05832380",
        longitude: "-74.40566120",
        name: "New Jersey"
    },
    {
        countryCode: "US",
        isoCode: "NM",
        latitude: "34.51994020",
        longitude: "-105.87009010",
        name: "New Mexico"
    },
    {
        countryCode: "US",
        isoCode: "NV",
        latitude: "38.80260970",
        longitude: "-116.41938900",
        name: "Nevada"
    },
    {
        countryCode: "US",
        isoCode: "NY",
        latitude: "40.71277530",
        longitude: "-74.00597280",
        name: "New York"
    },
    {
        countryCode: "US",
        isoCode: "OH",
        latitude: "40.41728710",
        longitude: "-82.90712300",
        name: "Ohio"
    },
    {
        countryCode: "US",
        isoCode: "OK",
        latitude: "35.46756020",
        longitude: "-97.51642760",
        name: "Oklahoma"
    },
    {
        countryCode: "US",
        isoCode: "OR",
        latitude: "43.80413340",
        longitude: "-120.55420120",
        name: "Oregon"
    },
    {
        countryCode: "US",
        isoCode: "PA",
        latitude: "41.20332160",
        longitude: "-77.19452470",
        name: "Pennsylvania"
    },
    {
        countryCode: "US",
        isoCode: "PR",
        latitude: "18.22083300",
        longitude: "-66.59014900",
        name: "Puerto Rico"
    },
    {
        countryCode: "US",
        isoCode: "RI",
        latitude: "41.58009450",
        longitude: "-71.47742910",
        name: "Rhode Island"
    },
    {
        countryCode: "US",
        isoCode: "SC",
        latitude: "33.83608100",
        longitude: "-81.16372450",
        name: "South Carolina"
    },
    {
        countryCode: "US",
        isoCode: "SD",
        latitude: "43.96951480",
        longitude: "-99.90181310",
        name: "South Dakota"
    },
    {
        countryCode: "US",
        isoCode: "TN",
        latitude: "35.51749130",
        longitude: "-86.58044730",
        name: "Tennessee"
    },
    {
        countryCode: "US",
        isoCode: "TX",
        latitude: "31.96859880",
        longitude: "-99.90181310",
        name: "Texas"
    },
    {
        countryCode: "US",
        isoCode: "UM",
        latitude: "19.28231920",
        longitude: "166.64704700",
        name: "United States Minor Outlying Islands"
    },
    {
        countryCode: "US",
        isoCode: "UM-67",
        latitude: "16.72950350",
        longitude: "-169.53364770",
        name: "Johnston Atoll"
    },
    {
        countryCode: "US",
        isoCode: "UM-71",
        latitude: "28.20721680",
        longitude: "-177.37349260",
        name: "Midway Atoll"
    },
    {
        countryCode: "US",
        isoCode: "UM-76",
        latitude: "18.41006890",
        longitude: "-75.01146120",
        name: "Navassa Island"
    },
    {
        countryCode: "US",
        isoCode: "UM-79",
        latitude: "19.27961900",
        longitude: "166.64993480",
        name: "Wake Island"
    },
    {
        countryCode: "US",
        isoCode: "UM-81",
        latitude: "0.19362660",
        longitude: "-176.47690800",
        name: "Baker Island"
    },
    {
        countryCode: "US",
        isoCode: "UM-84",
        latitude: "0.81132190",
        longitude: "-176.61827360",
        name: "Howland Island"
    },
    {
        countryCode: "US",
        isoCode: "UM-86",
        latitude: "-0.37435030",
        longitude: "-159.99672060",
        name: "Jarvis Island"
    },
    {
        countryCode: "US",
        isoCode: "UM-89",
        latitude: "6.38333300",
        longitude: "-162.41666700",
        name: "Kingman Reef"
    },
    {
        countryCode: "US",
        isoCode: "UM-95",
        latitude: "5.88850260",
        longitude: "-162.07866560",
        name: "Palmyra Atoll"
    },
    {
        countryCode: "US",
        isoCode: "UT",
        latitude: "39.32098010",
        longitude: "-111.09373110",
        name: "Utah"
    },
    {
        countryCode: "US",
        isoCode: "VA",
        latitude: "37.43157340",
        longitude: "-78.65689420",
        name: "Virginia"
    },
    {
        countryCode: "US",
        isoCode: "VI",
        latitude: "18.33576500",
        longitude: "-64.89633500",
        name: "United States Virgin Islands"
    },
    {
        countryCode: "US",
        isoCode: "VT",
        latitude: "44.55880280",
        longitude: "-72.57784150",
        name: "Vermont"
    },
    {
        countryCode: "US",
        isoCode: "WA",
        latitude: "47.75107410",
        longitude: "-120.74013850",
        name: "Washington"
    },
    {
        countryCode: "US",
        isoCode: "WI",
        latitude: "43.78443970",
        longitude: "-88.78786780",
        name: "Wisconsin"
    },
    {
        countryCode: "US",
        isoCode: "WV",
        latitude: "38.59762620",
        longitude: "-80.45490260",
        name: "West Virginia"
    },
    {
        countryCode: "US",
        isoCode: "WY",
        latitude: "43.07596780",
        longitude: "-107.29028390",
        name: "Wyoming"
    }
];
